import request from '@/utils/request';

// baseURL声明
const jsonBaseUrl = import.meta.env.VITE_NEWS_JSON_BASEURL;
const apiBaseUrl = import.meta.env.VITE_NEWS_API_BASEURL;
const hcUrl = import.meta.env.VITE_HUACHENG;
const siteId = import.meta.env.VITE_SITE_ID;

// const DOMIN_API = 'https://mc.gzcmc.net';
const DOMIN_API = import.meta.env.VITE_DOMIN_API;

export function getTopicNewsByKeywordApi(params) {
  const newParams = {
    siteId,
  };
  Object.assign(newParams, params);
  const keys = Object.keys(newParams);
  const searchParams = new URLSearchParams();
  keys.map((key) => {
    searchParams.append(key, newParams[key]);
    return true;
  });
  return request({
    baseURL: apiBaseUrl,
    url: 'gb-xhc/topic/content/list',
    data: searchParams,
    method: 'post',
  });
}

/**
 * 通过频道信息获取稿件列表
 * @param {Object} params
 * @returns
 */
export function getChildChanneByCodelApi(params) {
  const newParams = {
    siteId,
  };
  Object.assign(newParams, params);
  const keys = Object.keys(newParams);
  const searchParams = new URLSearchParams();
  keys.map((key) => {
    searchParams.append(key, newParams[key]);
    return true;
  });
  return request({
    baseURL: apiBaseUrl,
    url: 'gb-xhc/gb/channel/getChildChannelListByCode',
    data: searchParams,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  });
}

/**
 * 根据频道alias等参数获取频道稿件列表
 * @param {Object} params
 * @returns
 */
export function getChannelNewsApi(params) {
  const newParams = {
    siteId,
  };
  Object.assign(newParams, params);
  return request({
    baseURL: apiBaseUrl,
    url: '/gb-xhc/gb/news/list',
    headers: {
      'Content-Type': 'application/json',
    },
    data: newParams,
    method: 'post',
  });
}

/**
 * 根据传参获取稿件详情(api)
 * @param {Object} params
 * @returns
 */
export function getContentDetailApi(params) {
  const newParams = {
    siteId,
  };
  Object.assign(newParams, params);
  return request({
    baseURL: apiBaseUrl,
    url: '/gb-xhc/gb/news/detail',
    params: newParams,
    method: 'get',
  });
}

/**
 * 增加阅读量(api)
 * @param {Object} params
 * @returns
 */
export function addReadCountLog(params) {
  const newParams = {
    siteId,
    platformCode: 'h5',
  };
  Object.assign(newParams, params);
  const keys = Object.keys(newParams);
  const searchParams = new URLSearchParams();
  keys.map((key) => {
    searchParams.append(key, newParams[key]);
    return true;
  });
  return request({
    baseURL: apiBaseUrl,
    url: '/gb-xhc/gb/news/addReadCountLog',
    data: searchParams,
    method: 'POST',
  });
}

/**
 * 根据alias获取轮播图列表(json)
 * @param {String} params
 * @returns
 */
export function getCarouselJson(params) {
  const d = new Date().getTime();
  const timestamp = parseInt((d - (d % (60 * 1000))) / 1000, 10);
  return request({
    baseURL: jsonBaseUrl,
    url: `/json/carousel/${params.alias}.carouseljson?t=${timestamp}`,
    method: 'get',
  });
}

/**
 * 根据频道alias获取稿件列表(json)
 * @param {Object} params
 * @returns
 */
export function getChannelNewsJson(params) {
  const d = new Date().getTime();
  const timestamp = parseInt((d - (d % (60 * 1000))) / 1000, 10);
  return request({
    baseURL: jsonBaseUrl,
    url: `/json/channel/${params.alias}/list.json?t=${timestamp}`,
    method: 'get',
  });
}

/**
 * 根据稿件必传参数获取稿件详情(detailjson)
 * @param {Object} params
 * @returns
 */
export function getDetailJson(params) {
  const d = new Date().getTime();
  const timestamp = parseInt((d - (d % (60 * 1000))) / 1000, 10);
  return request({
    baseURL: jsonBaseUrl,
    url: `/json/content/${params.year}/${params.month}/${params.date}/${params.newsId}.detailjson?t=${timestamp}`,
    method: 'get',
  });
}

/**
 * 根据稿件获取直播详情(livejson)
 * @param {Object} params
 * @returns
 */
export function getLiveJson(params) {
  const d = new Date().getTime();
  const timestamp = parseInt((d - (d % (60 * 1000))) / 1000, 10);
  return request({
    baseURL: jsonBaseUrl,
    url: `/json/scene/${params.year}/${params.month}/${params.date}/detail/${params.newsId}/${params.newsId}.livejson?t=${timestamp}`,
    method: 'get',
  });
}

/**
 * 获取互动直播分镜列表(json)
 * @param {Object} params
 * @returns
 */
export function getLiveReportJson(params) {
  const d = new Date().getTime();
  const timestamp = parseInt((d - (d % (60 * 1000))) / 1000, 10);
  return request({
    baseURL: jsonBaseUrl,
    url: `/json/scene/${params.year}/${params.month}/${params.date}/lives/${params.newsId}/${params.newsId}.livejson?t=${timestamp}`,
    method: 'get',
  });
}

/**
 * ??? 获取直播评论的接口(json)
 * @param {Object} params
 * @returns
 */
export function getLiveCommentJson(params) {
  const d = new Date().getTime();
  const timestamp = parseInt((d - (d % (60 * 1000))) / 1000, 10);
  return request({
    baseURL: jsonBaseUrl,
    url: `/json/scene/${params.year}/${params.month}/${params.date}/comment/${params.newsId}/${params.newsId}.livejson?t=${timestamp}`,
    method: 'get',
  });
}

/**
 * 获取图文直播内容列表(json)
 * @param {String} jsonUrl
 * @returns
 */
export function getNoLiveReportJson(jsonUrl) {
  const d = new Date().getTime();
  const timestamp = parseInt((d - (d % (60 * 1000))) / 1000, 10);
  return request({
    url: `${jsonUrl}?t=${timestamp}`,
    method: 'get',
  });
}

/**
 * 根据参数获取专题信息及专题稿件列表
 * @param {Object} params
 * @returns
 */
export function getTopicJson(params) {
  const d = new Date().getTime();
  const timestamp = parseInt((d - (d % (60 * 1000))) / 1000, 10);
  return request({
    baseURL: jsonBaseUrl,
    url: `/json/topic/${params.year}/${params.month}/${params.date}/${params.newsId}/${params.newsId}.topicjson?t=${timestamp}`,
    method: 'get',
  });
}

/**
 * 根据参数获取子栏目或专题分页后的稿件列表
 * @param {Object} params
 * @returns
 */
export function getGroupJson(params) {
  const d = new Date().getTime();
  const timestamp = parseInt((d - (d % (60 * 1000))) / 1000, 10);
  return request({
    baseURL: jsonBaseUrl,
    url: `/json/topic/${params.year}/${params.month}/${params.date}/${params.newsId}/${params.groupId}_${params.page}.topicjson?t=${timestamp}`,
    method: 'get',
  });
}


export function getRegionData() {
  const d = new Date().getTime();
  const timestamp = parseInt((d - (d % (60 * 1000))) / 1000, 10);
  return request({
    url: `https://wxapp.gz-cmc.com/wxapp/2025/h5/yueyunbei2025/region.json?t=${timestamp}`,
    method: 'get',
  });
}

export function enrollResult(name, phone, type) {
  return request({
    url: `${DOMIN_API}/cos/app/v1/enroll/apps/yy/enrollResult?name=${name}&phone=${phone}&type=${type}`,
    method: 'get',
  });
}

export function getRuWei() {
  const d = new Date().getTime();
  const timestamp = parseInt((d - (d % (60 * 1000))) / 1000, 10);
  return request({
    url: `https://wxapp.gz-cmc.com/wxapp/2025/h5/yueyunbei2025/json/ruwei.json?t=${timestamp}`,
    method: 'get',
  });
}

export function getCszs() {
  const d = new Date().getTime();
  const timestamp = parseInt((d - (d % (60 * 1000))) / 1000, 10);
  return request({
    url: `https://wxapp.gz-cmc.com/wxapp/2025/h5/yueyunbei2025/json/cszs.json?t=${timestamp}`,
    method: 'get',
  });
}



export function searchRecord(id, name, phone, type) {
  return request({
    url: `${DOMIN_API}/cos/app/v1/enroll/apps/yy/searchRecord`,
    method: 'post',
    data: {
      userId: id,
      name,
      phone,
      type,
    },
  });
}

//  粤韵杯获取希望学第三方页面跳转参数接口
export function xwxRedirectUrl2026(name, phone, opType) {
  return request({
    url: `${DOMIN_API}/cos/app/v1/enroll/apps/yyb/xwxRedirectUrl?name=${name}&phone=${phone}&opType=${opType}`,
    method: 'get',
  });
}

export function enrollResult2(name, phone, opType) {
  return request({
    url: `${DOMIN_API}/cos/app/v1/enroll/apps/yyb/enrollResult?name=${name}&phone=${phone}&type=${opType}&year=2026`,
    method: 'get',
  });
}

export function getYueyunSy26(name, phone, opType) {
  return request({
    url: `${hcUrl}/contentapi/api/yyb/getYueyunSy26?studentName=${name}&phone=${phone}&category=${opType}`,
    method: 'get',
  });
}

export function getYueyunZw26(name, phone, opType) {
  return request({
    url: `${hcUrl}/contentapi/api/yyb/getYueyunZw26?studentName=${name}&phone=${phone}&category=${opType}`,
    method: 'get',
  });
}

export function getYueyunGy26(name, phone, opType) {
  return request({
    url: `${hcUrl}/contentapi/api/yyb/getYueyunGy26?studentName=${name}&phone=${phone}&category=${opType}`,
    method: 'get',
  });
}

